<template>
  <div class="key-stats d-flex flex-row justify-content-start flex-wrap" v-if="Array.isArray(items) && items.length">
    <div class="d-flex flex-row align-items-center mb-2 mr-4" v-for="({ icon, label, value }, i) in items" :key="i">
      <font-awesome-icon class="text-primary-a5 mr-2" v-if="icon" :icon="icon" :size="iconSize"/>
      <div class="d-flex flex-column">
        <span class="d-block text-secondary-a5" v-if="!hideLabels && label">{{label}}</span>
        <span class="d-block text-secondary-a8" :class="{ 'font-weight-bold': !hideLabels && label }">{{value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    contentShare: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: String,
      default: '2x',
    },
    includeType: {
      type: Boolean,
      default: false,
    },
    hideLabels: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapRoot([ 'company' ]),
    items() {
      const items = [];

      if (this.includeType) {
        items.push({
          icon: 'newspaper',
          value: 'Content',
        });
      }

      if (this.contentShare && typeof this.contentShare.url === 'string') {
        items.push({
          icon: 'globe',
          value: this.contentShare.url.replace(/http(s)?:\/\/(www.)?/, '').split('/').shift(),
        });
      }

      return items;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/KeyStats.vue